<template>
  <div
    v-show="visible"
    :class="className"
    role="alert"
    @click="onClick"
  >
    <span>
      <font-awesome-icon
        v-if="icon"
        :icon="icon"
        class="mr-3"
      />
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'kind',
    event: 'kindupdated'
  },
  props: {
    kind: String, // primary, secondary, success, danger, warning, info
    icon: { // Font awesome icon
      type: Array,
      required: false,
      default: null
    },
    timeout: { // in miliseconds
      type: Number,
      required: false,
      default: 0
    },
    cssClass: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: function () {
    return {
      visible: true
    }
  },
  computed: {
    className () {
      return 'alert my-5 py-4 px-4 alert-' + this.kind + ' ' + this.cssClass
    }
  },
  mounted () {
    for (const i in this.$slots.default) {
      const slot = this.$slots.default[i]
      if (slot.tag === 'a') {
        slot.elm.addEventListener('click', (e) => {
          e.stopPropagation()
        })
      }
    }
    this.setTimeout()
  },
  methods: {
    onClick () {
      this.visible = false
      this.$emit('kindupdated', '')
    },
    setTimeout () {
      if (this.timeout > 0) {
        setTimeout(() => {
          this.visible = false
          this.$emit('kindupdated', '')
        }, this.timeout * 1000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.alert {
  cursor: pointer;
  &-primary {
    border-color: $primary;
    background-color: $primary-light;
    color: $primary;
    a, a:visited, a:focus {
      color: $primary;
    }
  }
  &-secondary {
    border-color: $secondary;
    background-color: $secondary-light;
    color: $secondary;
    a, a:visited, a:focus {
      color: $secondary;
    }
  }
  &-success {
    border-color: $success;
    background-color: $success-light;
    color: $success;
    a, a:visited, a:focus {
      color: $success;
    }
  }
  &-danger {
    border-color: $danger;
    background-color: $danger-light;
    color: $danger;
    a, a:visited, a:focus {
      color: $danger;
    }
  }
  &-warning {
    border-color: $warning;
    background-color: $warning-light;
    color: $warning;
    a, a:visited, a:focus {
      color: $warning;
    }
  }
  &-info {
    border-color: $info;
    background-color: $info-light;
    color: $info;
    a, a:visited, a:focus {
      color: $info;
    }
  }
}
</style>
